/**
 * @generated SignedSource<<c033aa5ecf7bdd153f662d649b23ad32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ForgotPasswordInput = {
  clientMutationId?: string | null;
  email: string;
};
export type useAuthContext_ForgotPasswordMutation$variables = {
  input: ForgotPasswordInput;
};
export type useAuthContext_ForgotPasswordMutation$data = {
  readonly Auth: {
    readonly forgotPassword: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type useAuthContext_ForgotPasswordMutation = {
  response: useAuthContext_ForgotPasswordMutation$data;
  variables: useAuthContext_ForgotPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ForgotPasswordPayload",
        "kind": "LinkedField",
        "name": "forgotPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_ForgotPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_ForgotPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f44b369b34873dfe1bb44a0504642b75",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_ForgotPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_ForgotPasswordMutation(\n  $input: ForgotPasswordInput!\n) {\n  Auth {\n    forgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "edf8b5f05c485a5895df26b3a81c00ca";

export default node;
